import { Grid, Typography } from '@mui/material'
import React from 'react'
import useStyles from './useStyles'

export const BoxDetails = ({ item = null }) => {
  const classes = useStyles()

  const formatDate = (date) => {
    let formattedDate
    if (date) {
      const newDate = new Date(date)
      formattedDate =
        newDate.getDate() +
        '/' +
        (newDate.getMonth() + 1) +
        '/' +
        newDate.getFullYear()
    }
    return formattedDate
  }

  return (
    item && (
      <Grid container className={classes.boxDetails}>
        <Grid item xs={12}>
          <Typography
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              color: '#4B4952',
              paddingLeft: 10,
              borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
            }}
          >
            Detalles
          </Typography>
        </Grid>
        <Grid container style={{ padding: 10 }}>
          <Grid item xs={4}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              Código de aplicación:
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {item.appCode}
            </Typography>
          </Grid>

          <Grid item xs={4} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              Estado de acceso a la aplicación:
            </Typography>
          </Grid>
          <Grid item xs={8} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {item.orgAppAccessStatusCode}
            </Typography>
          </Grid>

          <Grid item xs={4} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              Version base de Mi Estudio:
            </Typography>
          </Grid>
          <Grid item xs={8} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {item.baseApplicationInstance ? 'Si' : 'No'}
            </Typography>
          </Grid>

          <Grid item xs={4} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              Colaboradores activos:
            </Typography>
          </Grid>
          <Grid item xs={8} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {item.activeAppUserCount}
            </Typography>
          </Grid>

          <Grid item xs={4} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              Usuarios de cliente activos (Invitados):
            </Typography>
          </Grid>
          <Grid item xs={8} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {item.activeExternalAppUserCount}
            </Typography>
          </Grid>

          <Grid item xs={4} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              Habilitación desde:
            </Typography>
          </Grid>
          <Grid item xs={8} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {formatDate(item.accessStartDate)
                ? formatDate(item.accessStartDate)
                : 'Fecha no definida'}
            </Typography>
          </Grid>

          <Grid item xs={4} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              Habilitación hasta:
            </Typography>
          </Grid>
          <Grid item xs={6} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {formatDate(item.accessFinishDate)
                ? formatDate(item.accessFinishDate)
                : 'Fecha no definida'}
            </Typography>
          </Grid>
          <Grid item xs={4} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,

                fontWeight: 'bold',
                color: '#485450'
              }}
            >
              ID de instancia aplicación:
            </Typography>
          </Grid>
          <Grid item xs={8} style={{ paddingTop: 3 }}>
            <Typography
              style={{
                fontSize: 14,
                fontWeight: 'bold',
                color: '#6e7a76'
              }}
            >
              {item.applicationInstanceId}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    )
  )
}
